import AVText from 'src/components/elements/AVText';
import Styles from '../../Styles';
import {
  Dimensions,
  Image,
  Platform,
  StyleProp,
  TextStyle,
  View,
} from 'react-native';
import Localized from 'src/constants/AppStrings';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import CustomTextInput from 'src/components/elements/CustomTextInput';
import Settings from 'src/Settings';
import Svg, {Path, Defs, LinearGradient, Stop, G} from 'react-native-svg';
import {capitalizeFirstWord} from 'src/Util';
import TRialBlazerIconWeb from 'src/components/img/svg/rewards/TRialBlazerIconWeb';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

export function getFocusAwareStatusBar() {
  return null;
}
export function linkExistingAccountStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    container: {
      flex: 1,
      padding: Styles.Spacing.m3,
    },
    title: {
      fontSize: getLayoutDescriber().headerFontSize(),
      color: Styles.darkColor,
    },
  };
}

export function getWelcomeViewBckGrndStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    overlay: {},
    view: {
      flex: 1,
    },
  };
}

export function getWelcomeOverLayImage() {
  return null;
}
export function getRedeemColor() {
  return {
    backgroundColor: Styles.Colors.Aramark.primary,
    borderTopColor: Styles.Colors.Aramark.primary,
    borderBottomColor: Styles.Colors.Aramark.primary,
    borderLeftColor: Styles.Colors.Aramark.primary,
    borderRightColor: Styles.Colors.Aramark.primary,
    borderColor: Styles.Colors.Aramark.primary,
  };
}
export function renderYourBalanceRewardLbl(_styles, _accountStr) {
  return (
    <>
      <AVText
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
        style={_styles.payBalance}
      >
        {`${Localized.Labels.your_balance}: `}
        <AVFormattedCurrency
          testID={'balanceFormattedCurrency'}
          accessibilityLabel={
            _accountStr.getAccountBalance()
              ? `$${_accountStr.getAccountBalance().toString()}`
              : '0'
          }
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          style={_styles.payBalance}
          value={_accountStr.getAccountBalance() ?? 0}
          currency={_accountStr.getCurrency()}
        />
      </AVText>
    </>
  );
}

export function getOrTextDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    orText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      textTransform: 'uppercase',
    },
    solidLine: {
      backgroundColor: '#999',
    },
  };
}

export function getLineContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    lineContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginVertical: Styles.Spacing.m1,
    },
  };
}
export function getPasswordLoginTextStyleDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    passwordLoginText: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontFamily: Styles.FontFamily.gothamRegular,
    },
    passwordLoginTextColor: {
      color: Styles.Colors.Aramark.primary,
      textDecorationColor: Styles.Colors.Aramark.primary,
      fontFamily: Styles.FontFamily.gothamBold,
    },
  };
}
export function getWelcomeStatusBarStyleDescriptor(): string {
  return Styles.loginBackground;
}
export function getVersionTextDescriptor(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    versionText: {
      color: Styles.Colors.Aramark.primary,
      marginLeft: Styles.Spacing.m4,
    },
  };
}
export function getLogoContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    logoContainer: {
      alignSelf: 'center',
      height: Styles.Heights.h3,
      justifyContent: 'center',
      paddingTop: Styles.Spacing.m1,
      marginTop: -80,
      marginBottom: -20,
      flex: 1,
    },
  };
}

export function actionLinkText(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    actionLinkText: {
      color: Styles.Colors.Aramark.primary,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      fontFamily: Styles.FontFamily.gothamRegular,
      textDecorationLine: 'underline',
    },
    actionlinkView: {
      alignSelf: 'flex-start',
    },
  };
}

export function getWelcomeButtonStyles(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    topButton: {
      marginTop: Styles.Spacing.m3,
      alignSelf: 'auto',
      paddingVertical: Styles.Spacing.m1,
    },
  };
}

export function getContainer(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    container: {
      marginTop: 120,
    },
  };
}

export function locationCodebgColor(): string {
  return Styles.Colors.Aramark.primary;
}

export function renderPointsToNextRewardLbl(_styles, nextPoint) {
  const morePointsThanHigher = nextPoint < 0 ? true : false;
  return (
    <>
      <AVText
        style={_styles.pointsToNextRwd}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        testID="qa_RewardsNote_txt"
        nativeID="qa_RewardsNote_txt"
        adjustsFontSizeToFit={true}
        accessible
      >
        {!morePointsThanHigher
          ? Localized.Labels.formatString(
              Localized.Labels.points_next_rewrd,
              nextPoint,
            )
          : Localized.Labels.more_points_than_available}
      </AVText>
    </>
  );
}
export function onboardingLinklocationSuccessTextColor(): string {
  return Styles.Colors.Aramark.primary;
}
export function getOnBoardingButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  return (
    <>
      <RoundedAppButton
        buttonViewStyle={{width: '100%'}}
        textStyle={[
          {
            fontSize: getLayoutDescriber().bodyFontSize(),
            fontWeight: '700',
          },
          getSnackDescriber().snackDetailsBtnFontSTyle(),
          {
            flex: 1,
            textAlign: 'center',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
        isDisabled={disabled}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
          height: 43,
          width: '100%',
        }}
        inActiveTextStyle={{
          fontSize: getLayoutDescriber().bodyFontSize(),
          flex: 1,
          textAlign: 'center',
        }}
        buttonType={RoundedAppButtonType.Solid}
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
      />
    </>
  );
}

export function getLinkLocationButton(
  buttonText: string,
  handleClick: () => void,
  disabled?: boolean,
): JSX.Element {
  const width = Dimensions.get('window').width;
  return (
    <View
      style={{
        marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
        marginTop: Styles.Spacing.m3,
        alignSelf: 'center',
        width: Platform.OS === 'web' ? '100%' : null,
      }}
    >
      <RoundedAppButton
        buttonViewStyle={{width: '100%'}}
        buttonContainerStyle={{
          width: Platform.OS === 'web' ? '100%' : width,
          alignItems: 'center',
          justifyContent: 'center',
          paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
        }}
        textStyle={[
          {
            fontSize: getLayoutDescriber().bodyFontSize(),
            fontWeight: '700',
          },
        ]}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
        isDisabled={disabled}
        inActiveButtonViewStyle={{
          backgroundColor: Styles.Colors.PayNew.darkHuesBase04,
          width: '100%',
        }}
        inActiveTextStyle={{fontSize: getLayoutDescriber().bodyFontSize()}}
        buttonType={RoundedAppButtonType.Solid}
        titleText={buttonText}
        accessibilityLabelValue={buttonText}
        aria-label={buttonText}
        onPress={handleClick}
      />
    </View>
  );
}

export function getStatusSystem(): string {
  return Localized.Labels.pay_status_system;
}
export function getOneTimeTitle(): string {
  return Localized.Labels.one_time_rewards_title_aramark;
}
export function getOneTimePayEarnColor(): string {
  return Styles.Colors.Aramark.primary;
}
export function getLetsGoStyle() {
  return null;
}

export function getBodyTextStyles(): {
  [key: string]: {[key: string]: string | number};
} {
  return {
    bodyText: {
      textAlign: 'center',
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginTop: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.gothamRegular,
      fontStyle: 'normal',
      marginHorizontal: Styles.Spacing.m3,
    },
    supportingText: {
      fontFamily: Styles.FontFamily.gothamRegular,
      fontSize: getLayoutDescriber().bodySmallFontSize(),
      fontStyle: 'normal',
      fontWeight: '400',
      color: Styles.Colors.PayNew.darkHuesBase03,
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m3,
    },
    forgotPin: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginBottom: Styles.Spacing.m2,
      marginTop: Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.gothamRegular,
      marginRight: Styles.Spacing.m1,
    },
    forgotPinDescription: {
      color: Styles.Colors.PayNew.black01,
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '400',
      marginBottom: Styles.Spacing.m2,
      marginTop: -Styles.Spacing.m2,
      paddingStart: Styles.Spacing.m2,
      fontFamily: Styles.FontFamily.gothamRegular,
      marginRight: Styles.Spacing.m1,
      fontStyle: 'italic',
    },
  };
}

export function baseAccountContainerDescriptor(): {
  [key: string]: {[key: string]: number | string};
} {
  return {
    container: {
      backgroundColor: Styles.white,
      paddingBottom: Platform.OS === 'android' ? 10 : 0,
    },
    headerText: {
      marginTop: Styles.Spacing.m3,
      fontSize: getLayoutDescriber().subHeaderFontSize(),
      fontWeight: '700',
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.gothamRegular,
    },
  };
}
export function getRewardsIcon(size, props) {
  return (
    <Svg width={size ?? 70} height="67" viewBox="0 0 70 67" {...props}>
      <Path
        d="M0 33.5C0 15 14.91 0 33.305 0h3.39C55.09 0 70 15 70 33.5S55.09 67 36.695 67h-3.39C14.91 67 0 52 0 33.5zm0 0"
        stroke="none"
        fillRule="nonzero"
        fill={Styles.Colors.PayNew.neutralHuesBase12}
        fillOpacity={1}
      />
      <Path
        d="M33.512 20.36a5.567 5.567 0 00-4.797-2.758h-.137c-3 0-5.433 2.445-5.433 5.464 0 .895.214 1.739.593 2.485h-1.582a2.97 2.97 0 00-2.96 2.98v3.977c0 1.297.824 2.402 1.972 2.812v10.102c0 2.195 1.773 3.976 3.953 3.976H44.88c2.18 0 3.953-1.78 3.953-3.976V35.32a2.985 2.985 0 001.973-2.812V28.53a2.97 2.97 0 00-2.961-2.98h-1.582a5.47 5.47 0 00.593-2.485c0-3.02-2.433-5.464-5.433-5.464h-.137a5.567 5.567 0 00-4.797 2.757L35 22.91l-1.488-2.543zm14.332 8.171v3.977H36.977V28.53zm-14.82 0v3.977H22.155V28.53zm0 6.957v10.93H25.12a.996.996 0 01-.988-.996v-9.934zm3.953 10.93v-10.93h8.89v9.934a.996.996 0 01-.988.996zm4.445-20.867h-4.527l2.148-3.676a2.604 2.604 0 012.242-1.293h.137a2.477 2.477 0 012.469 2.484 2.477 2.477 0 01-2.47 2.485zm-8.399 0h-4.445a2.477 2.477 0 01-2.469-2.485 2.477 2.477 0 012.47-2.484h.136a2.6 2.6 0 012.242 1.293l2.148 3.676zm0 0"
        stroke="none"
        fillRule="nonzero"
        fill={Styles.Colors.Aramark.primary}
        fillOpacity={1}
      />
    </Svg>
  );
}
export function getTrailBlazerIcon(size, props) {
  if (Platform.OS === 'web') {
    const imageSource = require('src/components/img/svg/rewards/aramark/AramarkTrailBlazer.png');
    return imageSource ? (
      <Image
        source={imageSource}
        style={[
          {
            width: size ?? 183,
            height: size ?? 182,
          },
          props.style,
        ]}
        resizeMode="contain"
      />
    ) : null;
  } else {
    return (
      <Svg
        width={size ?? 183}
        height={size ?? 182}
        viewBox="0 0 182 182"
        fill="none"
        {...props}
      >
        <Path
          d="M91 177.45c47.745 0 86.45-38.705 86.45-86.45 0-47.745-38.705-86.45-86.45-86.45C43.255 4.55 4.55 43.255 4.55 91c0 47.745 38.705 86.45 86.45 86.45z"
          fill="url(#paint0_linear_1408_31550)"
        />
        <Path
          d="M91 163.8c40.583 0 73.482-32.899 73.482-73.483 0-40.583-32.899-73.482-73.482-73.482s-73.483 32.9-73.483 73.482c0 40.584 32.9 73.483 73.483 73.483z"
          fill="#F3F3F3"
        />
        <Path
          d="M122.986 121.371h-64.61a5.3 5.3 0 00-5.3 5.301v5.414a5.3 5.3 0 005.3 5.301h64.61a5.3 5.3 0 005.301-5.301v-5.414a5.3 5.3 0 00-5.301-5.301z"
          fill="url(#paint1_linear_1408_31550)"
        />
        <G
          style={{
            mixBlendMode: 'multiply',
          }}
          opacity={0.4}
        >
          <Path
            d="M53.557 132.264a5.81 5.81 0 004.797 2.551h64.61a5.81 5.81 0 004.795-2.55c-.095 2.554-2.219 4.622-4.795 4.622h-64.61c-2.577 0-4.702-2.069-4.797-4.623z"
            fill="#F9DEE2"
          />
          <Path
            d="M53.557 132.264a5.81 5.81 0 004.797 2.551h64.61a5.81 5.81 0 004.795-2.55c-.095 2.554-2.219 4.622-4.795 4.622h-64.61c-2.577 0-4.702-2.069-4.797-4.623z"
            stroke="#CFCFCF"
          />
        </G>
        <Path
          d="M80.103 120.165v21.227c0-.019.002.01-.037.108a2.858 2.858 0 01-.16.327c-.143.259-.34.559-.543.851-.202.289-.405.561-.558.761l-.184.238-.052.064-.012.017-.003.004-.001.001-.016.019-.013.02a.526.526 0 01-.446.218.524.524 0 01-.446-.218l-.013-.02-.016-.019v-.001l-.003-.004-.014-.017-.05-.064a22.702 22.702 0 01-.742-.999c-.204-.292-.401-.592-.545-.851a2.86 2.86 0 01-.16-.327c-.038-.098-.036-.127-.036-.108v-21.227h4.05z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M78.1 133.429h-.067c-.091 0-.16-.091-.16-.205v-2.252c0-.068.114-.296.114-.296.023-.068.091-.068.137 0 0 0 .113.228.113.296v2.252c0 .114-.068.205-.159.205h.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M80.899 131.336a.302.302 0 00-.296-.296h-5.096a.302.302 0 00-.296.296v5.528c0 .159.137.296.296.296.16 0 .296-.137.296-.296v-5.232h4.436v5.232c0 .159.137.296.296.296.16 0 .296-.137.296-.296 0 0 .068-5.46.068-5.551v.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M80.717 136.933h-5.3a.773.773 0 00-.774.773v.455c0 .427.346.774.773.774h5.301a.774.774 0 00.773-.774v-.455a.773.773 0 00-.773-.773zM80.717 127.514h-5.3a.773.773 0 00-.774.773v.455c0 .427.346.774.773.774h5.301a.774.774 0 00.773-.774v-.455a.773.773 0 00-.773-.773z"
          fill="#F3F3F3"
        />
        <Path
          d="M103.445 120.779v20.681c0-.019.002.008-.036.102a2.791 2.791 0 01-.158.319 9.792 9.792 0 01-.542.825 20.139 20.139 0 01-.792 1.03l-.014.016-.003.004-.001.001-.016.018-.012.02c-.083.121-.247.207-.451.207-.205 0-.369-.086-.452-.207l-.013-.02-.015-.018-.001-.001-.003-.004-.013-.016-.051-.062-.184-.231a19.145 19.145 0 01-.557-.737 9.632 9.632 0 01-.542-.825 2.7 2.7 0 01-.16-.319c-.037-.094-.035-.121-.035-.102v-20.681h4.051z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M101.397 133.429h.068c.091 0 .159-.091.159-.205v-2.252c0-.068-.114-.296-.114-.296-.022-.068-.091-.068-.136 0 0 0-.114.228-.114.296v2.252c0 .114.068.205.159.205h-.022z"
          fill="#F3F3F3"
        />
        <Path
          d="M98.576 131.336c0-.159.136-.296.296-.296h5.095c.16 0 .296.137.296.296v5.528a.301.301 0 01-.296.296.301.301 0 01-.295-.296v-5.232h-4.436v5.232a.302.302 0 01-.296.296.302.302 0 01-.296-.296s-.068-5.46-.068-5.551v.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M98.758 138.935h5.3a.774.774 0 00.774-.774v-.455a.773.773 0 00-.774-.773h-5.3a.773.773 0 00-.774.773v.455c0 .427.347.774.774.774zM98.758 129.698h5.3a.773.773 0 00.774-.773v-.455a.774.774 0 00-.774-.774h-5.3a.774.774 0 00-.774.774v.455c0 .427.347.773.774.773z"
          fill="#F3F3F3"
        />
        <Path
          d="M90.113 37.332c-3.39 0-6.165 4.982-6.165 11.148h1.365c0-5.438 2.138-9.874 4.777-9.874 2.639 0 4.778 4.413 4.778 9.873h1.365c0-6.165-2.753-11.147-6.143-11.147h.023z"
          fill="#D23580"
        />
        <Path
          d="M78.654 34.406l-3.307.745a3.117 3.117 0 00-2.355 3.725l2.78 12.34a3.117 3.117 0 003.726 2.355l3.307-.745A3.117 3.117 0 0085.16 49.1l-2.78-12.34a3.117 3.117 0 00-3.726-2.354zM97.339 52.816l3.307.745a3.116 3.116 0 003.725-2.355l2.781-12.34a3.116 3.116 0 00-2.355-3.726l-3.307-.745a3.117 3.117 0 00-3.726 2.355l-2.78 12.34a3.117 3.117 0 002.355 3.726z"
          fill="#D23580"
        />
        <Path
          d="M117.549 117.617h-3.412a5.427 5.427 0 01-5.415-5.414V95.459c0-1.16.933-2.093 2.093-2.093h10.078c1.161 0 2.093.932 2.093 2.093v16.744a5.427 5.427 0 01-5.414 5.414h-.023z"
          fill="url(#paint2_linear_1408_31550)"
        />
        <Path
          d="M114.319 91.363h4.549a4.335 4.335 0 014.346 4.346v2.116c0 .748-.618 1.365-1.365 1.365h-10.511a1.374 1.374 0 01-1.365-1.365V95.71a4.334 4.334 0 014.121-4.34l.225-.006z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M59.514 93.298h10.078c1.16 0 2.093.933 2.093 2.093v16.744a5.427 5.427 0 01-5.414 5.414h-3.413a5.427 5.427 0 01-5.414-5.414V95.391c0-1.16.932-2.093 2.093-2.093h-.023z"
          fill="url(#paint3_linear_1408_31550)"
        />
        <Path
          d="M69.07 99.122H58.558a1.374 1.374 0 01-1.366-1.365V95.64a4.335 4.335 0 014.346-4.346h4.55a4.335 4.335 0 014.346 4.346v2.116c0 .747-.618 1.365-1.366 1.365z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M83.925 51.073h12.353c10.53 0 19.065 8.536 19.065 19.066v44.612a6.413 6.413 0 01-6.416 6.416H71.276a6.413 6.413 0 01-6.416-6.416V70.139c0-10.366 8.27-18.8 18.573-19.06l.492-.006z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M108.927 118.209H71.276c-3.8 0-6.916-3.117-6.916-6.916v3.435c0 3.799 3.117 6.916 6.916 6.916h37.651c3.799 0 6.916-3.117 6.916-6.916v-3.435c0 3.799-3.117 6.916-6.916 6.916z"
          fill="#F8E1EC"
          opacity={0.4}
        />
        <Path
          d="M71.253 46.182h37.742a2.655 2.655 0 012.662 2.662v10.078c0 6.321-5.122 11.444-11.443 11.444h-20.18c-6.321 0-11.443-5.123-11.443-11.444V48.844l.013-.273a2.655 2.655 0 012.649-2.39z"
          fill="url(#paint4_linear_1408_31550)"
          stroke="#fff"
        />
        <Path
          d="M108.972 45.682H71.23c-1.729 0-3.162 1.433-3.162 3.162v1.524c0-1.729 1.433-3.162 3.162-3.162h37.742c1.729 0 3.163 1.433 3.163 3.162v-1.524c0-1.73-1.434-3.162-3.163-3.162z"
          fill="#D7263D"
          opacity={0.3}
        />
        <Path
          d="M71.253 92.09h37.742a2.655 2.655 0 012.662 2.663v15.038c0 6.321-5.122 11.443-11.443 11.443h-20.18c-6.321 0-11.443-5.122-11.443-11.443V94.753l.013-.272a2.655 2.655 0 012.649-2.39z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M109.314 92.09a2.345 2.345 0 012.343 2.345v4.277c0 5.638-4.575 10.192-10.192 10.192h-22.66c-5.637 0-10.191-4.575-10.192-10.192v-4.277a2.345 2.345 0 012.344-2.344h38.357z"
          fill="url(#paint5_linear_1408_31550)"
          stroke="#fff"
        />
        <Path
          d="M79.876 75.62h20.474a2.617 2.617 0 012.617 2.617v5.688a2.617 2.617 0 01-2.617 2.616H79.876a2.617 2.617 0 01-2.618-2.616v-5.688a2.618 2.618 0 012.618-2.617z"
          fill="url(#paint6_linear_1408_31550)"
          stroke="#fff"
        />
        <Path
          d="M92.206 58.398v23.638c0 .004-.005.05-.043.151a3.352 3.352 0 01-.17.372c-.15.29-.357.625-.57.949a24.781 24.781 0 01-.774 1.112l-.053.071-.014.019-.003.005h-.001l-.018.024-.014.025c-.189.32-.721.342-.94-.011l-.013-.02-.015-.02h-.001l-.003-.005-.014-.018-.053-.07a24.732 24.732 0 01-.774-1.104 11.188 11.188 0 01-.568-.947 3.283 3.283 0 01-.17-.374 1.059 1.059 0 01-.037-.12c-.007-.032-.007-.043-.007-.039V58.398h4.255z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M90.135 70.524h-.068c-.09 0-.159-.09-.159-.227v-2.343c0-.069.136-.319.136-.319a.071.071 0 01.137 0s.136.25.136.319v2.343c0 .114-.068.227-.159.227h-.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M93.07 68.317a.325.325 0 00-.318-.318H87.45c-.16 0-.319.16-.319.319v5.778c0 .16.137.319.319.319a.311.311 0 00.319-.319v-5.46h4.618v5.46c0 .16.136.319.318.319a.311.311 0 00.319-.319l.068-5.779h-.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M92.911 74.165h-5.574a.796.796 0 00-.796.796v.5c0 .44.356.797.796.797h5.574c.44 0 .796-.356.796-.796v-.5a.796.796 0 00-.796-.797zM92.911 62.585h-5.574a.796.796 0 00-.796.796v.5c0 .44.356.797.796.797h5.574c.44 0 .796-.356.796-.796v-.5a.796.796 0 00-.796-.797zM90.204 78.533a.455.455 0 100-.91.455.455 0 000 .91zM90.204 80.58a.455.455 0 100-.91.455.455 0 000 .91zM90.204 82.605a.455.455 0 100-.91.455.455 0 000 .91z"
          fill="#F3F3F3"
        />
        <Path
          d="M80.536 91.41v25.639a.818.818 0 01-.047.2 3.927 3.927 0 01-.167.412c-.146.317-.345.682-.549 1.033a25.542 25.542 0 01-.745 1.203l-.052.079-.013.019-.002.005-.001.001-.013.019-.01.019c-.198.359-.655.359-.852 0l-.011-.019-.013-.019V120l-.004-.005-.013-.019-.051-.079a25.702 25.702 0 01-.745-1.203 12.921 12.921 0 01-.55-1.033 3.905 3.905 0 01-.166-.412.813.813 0 01-.047-.2v-25.64h4.05z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M78.533 109.746h-.068c-.091 0-.16-.091-.16-.204v-2.253c0-.068.114-.295.114-.295.023-.069.091-.069.137 0 0 0 .114.227.114.295v2.253c0 .113-.069.204-.16.204h.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M81.354 107.653a.302.302 0 00-.296-.296h-5.096a.302.302 0 00-.296.296v5.528a.3.3 0 00.296.296.3.3 0 00.296-.296v-5.232h4.436v5.232a.3.3 0 00.296.296.3.3 0 00.296-.296s.068-5.46.068-5.551v.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M81.15 113.227h-5.302a.773.773 0 00-.773.773v.455c0 .427.346.774.773.774h5.301a.774.774 0 00.774-.774V114a.773.773 0 00-.774-.773zM81.15 102.147h-5.302a.774.774 0 00-.773.774v.455c0 .427.346.773.773.773h5.301a.773.773 0 00.774-.773v-.455a.774.774 0 00-.774-.774zM81.15 97.143h-5.302a.773.773 0 00-.773.773v.455c0 .427.346.774.773.774h5.301a.773.773 0 00.774-.774v-.455a.773.773 0 00-.774-.773z"
          fill="#F3F3F3"
        />
        <Path
          d="M103.877 91.41v25.639a.81.81 0 01-.047.2 3.884 3.884 0 01-.167.412 12.9 12.9 0 01-.548 1.033c-.204.35-.408.677-.561.917-.077.12-.14.219-.185.286l-.051.079-.013.019-.003.005-.001.001-.013.019-.01.019c-.197.359-.655.359-.852 0l-.011-.019-.012-.019-.001-.001-.003-.005-.014-.019-.051-.079a24.514 24.514 0 01-.745-1.203 12.926 12.926 0 01-.549-1.033 3.98 3.98 0 01-.167-.412.813.813 0 01-.047-.2v-25.64h4.051z"
          fill="#D23580"
          stroke="#fff"
        />
        <Path
          d="M101.829 109.746h.068c.091 0 .159-.091.159-.204v-2.253c0-.068-.113-.295-.113-.295-.023-.069-.091-.069-.137 0 0 0-.114.227-.114.295v2.253c0 .113.069.204.16.204h-.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M99.03 107.653c0-.159.137-.296.296-.296h5.096c.16 0 .296.137.296.296v5.528a.3.3 0 01-.296.296.3.3 0 01-.295-.296v-5.232h-4.436v5.232a.3.3 0 01-.296.296.3.3 0 01-.296-.296s-.068-5.46-.068-5.551v.023z"
          fill="#F3F3F3"
        />
        <Path
          d="M99.213 115.252h5.3a.773.773 0 00.774-.774v-.455a.773.773 0 00-.774-.773h-5.3a.773.773 0 00-.774.773v.455c0 .428.347.774.774.774zM99.213 104.149h5.3a.773.773 0 00.774-.773v-.455a.774.774 0 00-.774-.774h-5.3a.774.774 0 00-.774.774v.455c0 .427.347.773.774.773zM99.213 99.531h5.3a.773.773 0 00.774-.773v-.455a.773.773 0 00-.774-.774h-5.3a.773.773 0 00-.774.774v.455c0 .427.347.773.774.773z"
          fill="#F3F3F3"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_1408_31550"
            x1={4.54999}
            y1={90.9998}
            x2={177.45}
            y2={90.9998}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#71C7D3" />
            <Stop offset={1} stopColor="#71C7D3" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_1408_31550"
            x1={53.0757}
            y1={129.356}
            x2={128.265}
            y2={129.356}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_1408_31550"
            x1={108.722}
            y1={105.491}
            x2={122.964}
            y2={105.491}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_1408_31550"
            x1={57.4437}
            y1={105.401}
            x2={71.6852}
            y2={105.401}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_1408_31550"
            x1={68.068}
            y1={58.2624}
            x2={112.135}
            y2={58.2624}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_1408_31550"
            x1={68.068}
            y1={100.486}
            x2={112.135}
            y2={100.486}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_1408_31550"
            x1={76.7585}
            y1={81.0806}
            x2={103.467}
            y2={81.0806}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D23580" />
            <Stop offset={1} stopColor="#D23580" />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  }
}
export function getLocationCodeText(
  state,
  maxCharacters,
  doSetState,
  locationNote,
) {
  return (
    <CustomTextInput
      label={Localized.Labels.location_code}
      value={state.locationCode}
      accessible={true}
      accessibilityLabel={Localized.Labels.location_code}
      accessibilityHint={Localized.Labels.please_enter_location_code}
      onChangeText={doSetState}
      accessibilityValue={{text: state.locationCode}}
      autoCapitalize="none"
      showHelpText={true}
      helpText={locationNote}
      maxLength={maxCharacters}
      maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm8}
      helperStyle={
        Settings.buildType === 'default'
          ? {
              fontFamily: Styles.FontFamily.gothamRegular,
              fontSize: getLayoutDescriber().bodySmallFontSize(),
              fontWeight: '400',
              left: 10,
            }
          : null
      }
      showShadow={true}
      outlineStyle={{
        borderRadius: 8,
      }}
      testID="qa_fld_LocationCode"
      helpTextTestId="qa_LinkLocationPrompt_txt"
      textStyle={{
        fontFamily: Styles.FontFamily.gothamRegular,
        fontSize: getLayoutDescriber().subHeaderFontSize(),
        fontWeight: '400',
      }}
    />
  );
}
export function getMemberTier(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 182 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91 177.45c47.745 0 86.45-38.705 86.45-86.45 0-47.745-38.705-86.45-86.45-86.45C43.255 4.55 4.55 43.255 4.55 91c0 47.745 38.705 86.45 86.45 86.45z"
        fill="url(#paint0_linear_1376_28284)"
      />
      <Path
        d="M91 163.8c40.583 0 73.482-32.899 73.482-73.483 0-40.583-32.899-73.482-73.482-73.482s-73.483 32.9-73.483 73.482c0 40.584 32.9 73.483 73.483 73.483z"
        fill="#F3F3F3"
      />
      <Path
        d="M116.344 106.925a7.235 7.235 0 00-1.115 3.026c-.66 4.823-5.688 7.735-10.215 5.892a7.427 7.427 0 00-8.713 2.343 7.406 7.406 0 01-5.187 2.844l-.705 1.251 15.743 27.55 8.258-14.696 17.927-.273-11.102-19.429-4.869-8.508h-.022z"
        fill="url(#paint1_linear_1376_28284)"
      />
      <Path
        d="M84.516 118.164a7.492 7.492 0 00-8.713-2.344c-4.504 1.843-9.555-1.069-10.215-5.892a7.576 7.576 0 00-1.114-3.026v.046c-.023 0-4.869 8.463-4.869 8.463l-11.102 19.428 17.2.797 8.963 14.15 15.743-27.55-.706-1.251a7.451 7.451 0 01-5.187-2.844v.023z"
        fill="url(#paint2_linear_1376_28284)"
      />
      <Path
        d="M89.703 121.03l.706 1.252.705-1.252a7.46 7.46 0 01-1.434 0h.023z"
        fill="url(#paint3_linear_1376_28284)"
      />
      <Path
        d="M89.703 121.03l.706 1.252.705-1.252a7.46 7.46 0 01-1.434 0h.023z"
        fill="url(#paint4_linear_1376_28284)"
      />
      <Path
        d="M90.409 83.606l9.623 5.505 7.03 4.027-12.445 21.772-3.503 6.142a7.45 7.45 0 005.187-2.843 7.492 7.492 0 018.713-2.344c4.505 1.843 9.555-1.069 10.215-5.892a7.569 7.569 0 011.115-3.026L99.918 78.191l-9.51 5.438v-.023z"
        fill="url(#paint5_linear_1376_28284)"
      />
      <Path
        d="M75.803 115.843a7.427 7.427 0 018.713 2.343 7.406 7.406 0 005.187 2.844L73.755 93.116l16.654-9.51-9.51-5.437-4.413 7.735-12.013 21.021a7.245 7.245 0 011.115 3.026c.66 4.823 5.688 7.735 10.215 5.892z"
        fill="url(#paint6_linear_1376_28284)"
      />
      <Path
        d="M107.062 93.115l-7.03-4.026-9.623-5.506-16.653 9.51 15.947 27.914c.478.045.956.045 1.434 0l3.503-6.143 12.444-21.772-.022.023z"
        fill="url(#paint7_linear_1376_28284)"
      />
      <Path
        d="M107.062 93.115l-7.03-4.026-9.623-5.506-16.653 9.51 15.947 27.914c.478.045.956.045 1.434 0l3.503-6.143 12.444-21.772-.022.023z"
        fill="url(#paint8_linear_1376_28284)"
      />
      <Path
        d="M96.3 34.922a7.492 7.492 0 008.714 2.343c4.505-1.843 9.555 1.07 10.215 5.892.455 3.322 3.071 5.938 6.37 6.37 4.823.66 7.735 5.688 5.892 10.215a7.428 7.428 0 002.343 8.713c3.845 2.98 3.845 8.804 0 11.785a7.492 7.492 0 00-2.343 8.713c1.843 4.504-1.069 9.555-5.892 10.215-3.322.455-5.938 3.071-6.37 6.37-.66 4.823-5.688 7.735-10.215 5.892a7.427 7.427 0 00-8.713 2.343c-2.98 3.845-8.804 3.845-11.785 0a7.492 7.492 0 00-8.713-2.343c-4.504 1.843-9.555-1.069-10.215-5.892-.455-3.322-3.071-5.938-6.37-6.37-4.823-.66-7.735-5.688-5.892-10.215a7.427 7.427 0 00-2.343-8.713c-3.845-2.98-3.845-8.805 0-11.785a7.492 7.492 0 002.343-8.713c-1.843-4.505 1.07-9.555 5.892-10.215 3.322-.455 5.938-3.071 6.37-6.37.66-4.823 5.688-7.735 10.215-5.892a7.427 7.427 0 008.713-2.343c2.98-3.845 8.804-3.845 11.785 0z"
        fill="url(#paint9_linear_1376_28284)"
      />
      <Path
        d="M114.432 74.347c0 12.877-10.442 23.32-23.296 23.32-12.853 0-8.826-1.32-12.421-3.573-6.552-4.117-10.897-11.42-10.897-19.724 0-12.876 10.442-23.296 23.296-23.296 12.853 0 10.783 2.002 14.81 5.301 5.187 4.277 8.486 10.738 8.486 17.995l.022-.023z"
        fill="#F3F3F3"
      />
      <Path
        d="M105.481 88.643c7.898-7.898 7.898-20.704 0-28.602s-20.704-7.898-28.602 0-7.898 20.704 0 28.602 20.704 7.898 28.602 0z"
        fill="url(#paint10_linear_1376_28284)"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_1376_28284"
          x1={4.55005}
          y1={90.9998}
          x2={177.45}
          y2={90.9998}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#71C7D3" />
          <Stop offset={1} stopColor="#71C7D3" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1376_28284"
          x1={73.1641}
          y1={128.378}
          x2={131.723}
          y2={128.378}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1376_28284"
          x1={48.5031}
          y1={128.378}
          x2={107.062}
          y2={128.378}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1376_28284"
          x1={0.000209133}
          y1={121.645}
          x2={0.227709}
          y2={121.645}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_1376_28284"
          x1={48.5031}
          y1={121.645}
          x2={107.062}
          y2={121.645}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_1376_28284"
          x1={0.0000659372}
          y1={99.5992}
          x2={0.227566}
          y2={99.5992}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#F3F3F3" />
        </LinearGradient>
        <LinearGradient
          id="paint6_linear_1376_28284"
          x1={48.503}
          y1={99.5994}
          x2={107.062}
          y2={99.5994}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#F3F3F3" />
          <Stop offset={1} stopColor="#F3F3F3" />
        </LinearGradient>
        <LinearGradient
          id="paint7_linear_1376_28284"
          x1={0.000111107}
          y1={102.329}
          x2={0.227611}
          y2={102.329}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint8_linear_1376_28284"
          x1={48.5031}
          y1={102.329}
          x2={107.062}
          y2={102.329}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint9_linear_1376_28284"
          x1={48.0936}
          y1={74.3474}
          x2={132.724}
          y2={74.3474}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint10_linear_1376_28284"
          x1={70.9419}
          y1={74.3523}
          x2={111.391}
          y2={74.3523}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
export function getEliteBuyerTier(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 182 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91 177.45c47.745 0 86.45-38.705 86.45-86.45 0-47.745-38.705-86.45-86.45-86.45C43.255 4.55 4.55 43.255 4.55 91c0 47.745 38.705 86.45 86.45 86.45z"
        fill="url(#paint0_linear_1408_31845)"
      />
      <Path
        d="M91.228 164.483c40.583 0 73.482-32.9 73.482-73.483 0-40.583-32.899-73.482-73.483-73.482-40.583 0-73.482 32.899-73.482 73.482s32.9 73.483 73.483 73.483z"
        fill="#F3F3F3"
      />
      <Path
        d="M104.582 147.192h-.114c-.318 0-8.008-.592-17.495-4.141-12.626-4.732-22.386-12.581-28.21-22.682-9.737-16.88-12.285-34.375-12.717-46.068-.455-12.672 1.342-21.272 1.433-21.636a1.54 1.54 0 011.843-1.183 1.54 1.54 0 011.183 1.843c0 .091-1.82 8.645-1.342 20.953.432 11.33 2.912 28.233 12.308 44.522 6.893 11.943 18.222 18.177 26.526 21.294 9.077 3.412 16.63 3.981 16.721 3.981a1.538 1.538 0 011.434 1.661c-.046.819-.728 1.433-1.547 1.433l-.023.023z"
        fill="url(#paint1_linear_1408_31845)"
      />
      <Path
        d="M51.392 44.817c3.003.41.137 17.631-3.435 16.084-3.572-1.547-.41-16.607 3.435-16.084zM57.717 62.334c2.707 1.911-7.69 14.037-10.17 11.716-2.48-2.32 7.417-13.65 10.17-11.716z"
        fill="#D23580"
      />
      <Path
        d="M37.31 62.334C34.603 64.245 45 76.371 47.48 74.05c2.479-2.32-7.417-13.65-10.17-11.716zM58.672 74.801c2.708 1.911-7.69 14.037-10.169 11.716-2.48-2.32 7.416-13.65 10.17-11.716z"
        fill="#D23580"
      />
      <Path
        d="M38.266 74.801c-2.708 1.911 7.689 14.037 10.169 11.716 2.48-2.32-7.417-13.65-10.17-11.716zM60.037 87.314c2.958 1.547-5.55 14.878-8.349 12.899-2.798-1.98 5.346-14.469 8.35-12.9z"
        fill="#D23580"
      />
      <Path
        d="M39.835 89.953c-2.411 2.23 9.669 12.899 11.785 10.283 2.116-2.617-9.35-12.558-11.785-10.283zM63.336 100.236c3.14 1.183-3.526 15.425-6.552 13.787s3.367-14.97 6.552-13.787z"
        fill="#D23580"
      />
      <Path
        d="M43.635 105.196c-2.093 2.502 11.306 11.671 13.058 8.827 1.752-2.844-10.943-11.352-13.058-8.827zM67.59 110.701c3.322.637-.546 15.766-3.822 14.651-3.299-1.092.455-15.311 3.822-14.651z"
        fill="#D23580"
      />
      <Path
        d="M49.163 118.914c-1.57 2.821 13.354 9.578 14.537 6.507 1.183-3.094-12.922-9.351-14.537-6.507zM73.164 119.255c3.39-.159 3.708 15.379.227 15.083-3.48-.295-3.662-14.924-.227-15.083z"
        fill="#D23580"
      />
      <Path
        d="M57.535 131.517c-.774 3.094 15.493 6.143 15.811 2.867.319-3.253-15.015-6.006-15.811-2.867z"
        fill="#D23580"
      />
      <Path
        d="M77.282 147.192a1.56 1.56 0 01-1.547-1.433c-.069-.864.591-1.592 1.433-1.661.068 0 7.621-.568 16.698-3.981 8.304-3.117 19.656-9.35 26.527-21.294 9.396-16.289 11.875-33.215 12.308-44.522.455-12.307-1.342-20.884-1.342-20.952a1.557 1.557 0 011.182-1.843 1.54 1.54 0 011.843 1.183c.069.364 1.889 8.94 1.434 21.635-.433 11.694-2.981 29.188-12.718 46.069-5.824 10.101-15.584 17.95-28.21 22.682-9.487 3.549-17.176 4.117-17.495 4.14h-.113v-.023z"
        fill="url(#paint2_linear_1408_31845)"
      />
      <Path
        d="M130.494 44.817c-3.003.41-.137 17.631 3.435 16.084 3.572-1.547.41-16.607-3.435-16.084zM124.17 62.334c-2.708 1.911 7.689 14.037 10.169 11.716 2.48-2.32-7.417-13.65-10.169-11.716z"
        fill="#D23580"
      />
      <Path
        d="M144.576 62.334c2.708 1.911-7.689 14.037-10.169 11.716-2.48-2.32 7.417-13.65 10.169-11.716zM123.214 74.801c-2.707 1.911 7.689 14.037 10.169 11.716 2.48-2.32-7.416-13.65-10.169-11.716z"
        fill="#D23580"
      />
      <Path
        d="M143.598 74.801c2.707 1.911-7.69 14.037-10.169 11.716-2.48-2.32 7.416-13.65 10.169-11.716zM121.826 87.314c-2.957 1.547 5.551 14.878 8.35 12.899 2.798-1.98-5.347-14.469-8.35-12.9z"
        fill="#D23580"
      />
      <Path
        d="M142.051 89.953c2.412 2.23-9.669 12.899-11.785 10.283-2.115-2.617 9.351-12.558 11.785-10.283zM118.528 100.236c-3.14 1.183 3.526 15.425 6.551 13.787 3.026-1.638-3.366-14.97-6.551-13.787z"
        fill="#D23580"
      />
      <Path
        d="M138.229 105.196c2.093 2.502-11.307 11.671-13.058 8.827-1.752-2.844 10.942-11.352 13.058-8.827zM114.296 110.701c-3.321.637.546 15.766 3.822 14.651 3.299-1.092-.455-15.311-3.822-14.651z"
        fill="#D23580"
      />
      <Path
        d="M132.724 118.914c1.569 2.821-13.355 9.578-14.538 6.507-1.183-3.094 12.922-9.351 14.538-6.507zM108.699 119.255c-3.389-.159-3.708 15.379-.227 15.083 3.481-.295 3.663-14.924.227-15.083z"
        fill="#D23580"
      />
      <Path
        d="M124.351 131.517c.774 3.094-15.492 6.143-15.811 2.867-.318-3.253 15.015-6.006 15.811-2.867zM94.89 100.782h-7.166l.25-2.547 1.229-11.808.296-2.957h3.617l1.774 17.312z"
        fill="#D23580"
      />
      <Path
        d="M92.342 98.12l-4.368.115 1.229-11.808 2.252-.204.887 11.898z"
        fill="#D23580"
      />
      <Path
        d="M96.369 98.621v1.388c0 .387-.319.728-.705.728H86.95a.714.714 0 01-.706-.728v-1.388c0-.386.319-.705.706-.705h8.713c.386 0 .705.319.705.705z"
        fill="#fff"
      />
      <Path
        d="M96.369 98.621v1.388c0 .387-.319.728-.705.728H86.95a.714.714 0 01-.706-.728v-.432c2.002.045 7.28.182 7.667 0 .387-.205 0-1.251-.182-1.661h1.911c.387 0 .705.319.705.705h.023z"
        fill="#D23580"
      />
      <Path
        d="M109.086 110.724H73.528l.227-1.866 1.07-8.144h32.942l1.069 8.144.25 1.866z"
        fill="url(#paint3_linear_1408_31845)"
      />
      <Path
        d="M109.086 110.724H73.528l.227-1.866h35.081l.25 1.866z"
        fill="#fff"
      />
      <Path
        d="M109.609 110.724H73.005c-.774 0-1.41.637-1.41 1.41 0 .774.636 1.411 1.41 1.411h36.604c.774 0 1.411-.637 1.411-1.411 0-.773-.637-1.41-1.411-1.41z"
        fill="#D23580"
      />
      <Path
        d="M112.317 66.475l-9.032 8.805 2.138 12.444c.296 1.683-1.478 2.957-2.98 2.161l-11.17-5.87-11.17 5.87c-.796.41-1.661.25-2.252-.227-.546-.433-.865-1.138-.728-1.957l2.138-12.444-9.032-8.804c-1.228-1.183-.546-3.276 1.138-3.504l12.49-1.82 5.573-11.307c.41-.841 1.274-1.228 2.093-1.137a1.99 1.99 0 011.593 1.137l5.573 11.307 12.49 1.82c1.684.25 2.366 2.32 1.138 3.504v.022z"
        fill="url(#paint4_linear_1408_31845)"
      />
      <Path
        d="M90.545 54.6c1.57 0-1.57 9.532-3.504 9.054-1.933-.478 2.162-9.054 3.504-9.054zM77.987 65.088c-.478 1.046 6.279 1.57 6.393.728.114-.842-5.779-2.048-6.393-.728z"
        fill="#F3F3F3"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_1408_31845"
          x1={4.55}
          y1={90.9998}
          x2={177.45}
          y2={90.9998}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#71C7D3" />
          <Stop offset={1} stopColor="#71C7D3" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1408_31845"
          x1={45.9778}
          y1={99.3256}
          x2={106.129}
          y2={99.3256}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1408_31845"
          x1={75.7347}
          y1={99.3263}
          x2={135.909}
          y2={99.3263}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1408_31845"
          x1={73.528}
          y1={105.719}
          x2={109.086}
          y2={105.719}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_1408_31845"
          x1={69.5695}
          y1={69.4101}
          x2={111.111}
          y2={69.4101}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
export function getTrialBlazerWebIcon() {
  return <TRialBlazerIconWeb />;
}

export function getSmartShopper(size, props) {
  return (
    <Svg
      width={size ?? 183}
      height={size ?? 182}
      viewBox="0 0 182 182"
      fill="none"
      {...props}
    >
      <Path
        d="M91 177.45c47.745 0 86.45-38.705 86.45-86.45 0-47.745-38.705-86.45-86.45-86.45C43.255 4.55 4.55 43.255 4.55 91c0 47.745 38.705 86.45 86.45 86.45z"
        fill="url(#paint0_linear_1408_31333)"
      />
      <Path
        d="M91 164.483c40.583 0 73.483-32.9 73.483-73.483 0-40.583-32.9-73.482-73.483-73.482-40.583 0-73.483 32.899-73.483 73.482s32.9 73.483 73.483 73.483z"
        fill="#F3F3F3"
      />
      <Path
        d="M125.762 74.78c0-19.816-16.585-35.74-36.627-34.694-17.95.955-32.465 15.97-32.852 33.943-.25 11.875 5.46 22.409 14.356 28.87 1.843 1.342 3.003 3.435 3.003 5.71v.773c0 2.071 1.547 3.618 3.48 3.618h27.801a3.481 3.481 0 003.481-3.481v-.933c0-2.275 1.137-4.345 2.98-5.687 8.713-6.302 14.401-16.54 14.401-28.142h-.023v.023z"
        fill="#F3F3F3"
      />
      <Path
        d="M125.762 74.78h1.251c0-9.942-4.027-18.951-10.556-25.458A35.898 35.898 0 0091 38.79c-.637 0-1.274 0-1.934.046-9.305.5-17.722 4.64-23.842 10.965-6.12 6.325-9.987 14.879-10.192 24.206v.774c0 5.983 1.456 11.648 4.05 16.607a36.155 36.155 0 0010.829 12.535 6.161 6.161 0 011.82 2.093c.432.797.66 1.684.66 2.617v.773c0 1.342.5 2.571 1.364 3.458.433.432.933.796 1.502 1.047.569.25 1.206.364 1.843.364h27.8c1.297 0 2.48-.524 3.344-1.388a4.672 4.672 0 001.388-3.344v-.933c0-.933.228-1.82.66-2.616a6.294 6.294 0 011.82-2.071 36.425 36.425 0 0010.852-12.512 35.817 35.817 0 004.072-16.63v-3.026l-2.161 2.161.887.887.887.888h.023l-.887-.91h-1.252c0 5.596-1.365 10.851-3.799 15.47a33.447 33.447 0 01-10.101 11.648 8.673 8.673 0 00-2.548 2.912 7.954 7.954 0 00-.955 3.776v.933c0 .614-.251 1.183-.66 1.57-.41.409-.956.659-1.57.659H77.1c-.319 0-.614-.068-.865-.182a2.262 2.262 0 01-.978-.819c-.25-.364-.387-.819-.387-1.365v-.773a8.11 8.11 0 00-.955-3.799 8.786 8.786 0 00-2.571-2.935 33.462 33.462 0 01-10.078-11.67 33.28 33.28 0 01-3.777-15.448v-.728c.182-8.645 3.777-16.608 9.487-22.5 5.71-5.915 13.536-9.76 22.181-10.215.615-.022 1.206-.045 1.797-.045 9.26 0 17.632 3.754 23.706 9.805 6.074 6.074 9.805 14.424 9.805 23.683v3.026l2.139-2.139-.888-.887.046.023z"
        fill="url(#paint1_linear_1408_31333)"
      />
      <Path
        d="M77.123 127.832v1.252H104.9c.614 0 1.16.25 1.57.659.409.41.66.956.66 1.57 0 .614-.251 1.16-.66 1.57-.41.409-.956.66-1.57.66H77.122c-.614 0-1.16-.251-1.57-.66-.409-.41-.659-.956-.659-1.57 0-.614.25-1.16.66-1.57.41-.409.955-.659 1.57-.659v-2.503a4.671 4.671 0 00-3.345 1.388 4.672 4.672 0 00-1.388 3.344 4.71 4.71 0 001.388 3.344 4.767 4.767 0 003.344 1.388H104.9a4.669 4.669 0 003.344-1.388 4.669 4.669 0 001.388-3.344c0-1.297-.523-2.48-1.388-3.344a4.764 4.764 0 00-3.344-1.388H77.122v1.251z"
        fill="url(#paint2_linear_1408_31333)"
      />
      <Path
        d="M97.962 112.999H94.48v-29.53h-6.939V113h-3.48v-29.53h-4.346c-4.3 0-7.826-3.503-7.826-7.826a7.826 7.826 0 017.826-7.826 7.826 7.826 0 017.826 7.826v4.346h6.939v-4.346c0-4.3 3.503-7.826 7.826-7.826a7.826 7.826 0 110 15.652h-4.346V113zm0-33.01h4.345a4.36 4.36 0 004.345-4.346 4.36 4.36 0 00-4.345-4.345 4.36 4.36 0 00-4.346 4.345v4.346zM79.716 71.32a4.36 4.36 0 00-4.345 4.345 4.36 4.36 0 004.345 4.345h4.345v-4.345a4.36 4.36 0 00-4.345-4.345z"
        fill="url(#paint3_linear_1408_31333)"
      />
      <Path
        d="M77.123 120.439v1.251H104.9a2.2 2.2 0 011.57.66 2.2 2.2 0 01.66 1.569c0 .615-.251 1.161-.66 1.57a2.2 2.2 0 01-1.57.66H77.122c-.614 0-1.16-.25-1.57-.66a2.199 2.199 0 010-3.139c.41-.41.956-.66 1.57-.66v-2.502a4.675 4.675 0 00-3.344 1.387 4.674 4.674 0 00-1.388 3.344c0 1.297.524 2.48 1.388 3.345a4.766 4.766 0 003.344 1.387H104.9a4.672 4.672 0 003.344-1.387 4.673 4.673 0 001.388-3.345 4.712 4.712 0 00-1.388-3.344 4.764 4.764 0 00-3.344-1.387H77.122v1.251z"
        fill="url(#paint4_linear_1408_31333)"
      />
      <Path
        d="M77.123 113.022v1.251H104.9a2.2 2.2 0 011.57.66c.409.409.66.955.66 1.57a2.2 2.2 0 01-.66 1.569 2.2 2.2 0 01-1.57.66H77.122c-.614 0-1.16-.25-1.57-.66a2.199 2.199 0 010-3.139c.41-.41.956-.66 1.57-.66v-2.502a4.675 4.675 0 00-3.344 1.387 4.675 4.675 0 00-1.388 3.345c0 1.296.524 2.479 1.388 3.344a4.767 4.767 0 003.344 1.388H104.9a4.673 4.673 0 003.344-1.388 4.672 4.672 0 001.388-3.344c0-1.297-.523-2.48-1.388-3.345a4.768 4.768 0 00-3.344-1.387H77.122v1.251z"
        fill="url(#paint5_linear_1408_31333)"
      />
      <Path
        d="M80.58 135.932h20.84a6.937 6.937 0 01-6.94 6.938h-6.938a6.937 6.937 0 01-6.939-6.938h-.022z"
        fill="#4D4D4D"
      />
      <Path
        d="M117.526 58.217l-2.934 1.843a26.713 26.713 0 012.434 4.913l3.253-1.228a32 32 0 00-2.73-5.528h-.023zM100.419 48.617a27.932 27.932 0 0110.214 6.484l2.457-2.457a31.428 31.428 0 00-11.511-7.303l-1.183 3.276h.023z"
        fill="#fff"
      />
      <Defs>
        <LinearGradient
          id="paint0_linear_1408_31333"
          x1={4.54999}
          y1={90.9998}
          x2={177.45}
          y2={90.9998}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#71C7D3" />
          <Stop offset={1} stopColor="#71C7D3" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_1408_31333"
          x1={55.0322}
          y1={70.1841}
          x2={127.036}
          y2={70.1841}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint2_linear_1408_31333"
          x1={72.3905}
          y1={131.29}
          x2={109.632}
          y2={131.29}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint3_linear_1408_31333"
          x1={71.89}
          y1={90.4081}
          x2={110.133}
          y2={90.4081}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint4_linear_1408_31333"
          x1={72.3905}
          y1={123.897}
          x2={109.632}
          y2={123.897}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
        <LinearGradient
          id="paint5_linear_1408_31333"
          x1={72.3905}
          y1={116.48}
          x2={109.632}
          y2={116.48}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#D23580" />
          <Stop offset={1} stopColor="#D23580" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export function getGoToSettings() {
  return Localized.Buttons.go_to_settings_receipt;
}

export function seeMoreDetailtxt() {
  return capitalizeFirstWord(Localized.Buttons.see_more_details);
}
export function getManualLinktxt() {
  return Localized.Buttons.manually_link_your_location;
}
export function locationCodeSaveButtonTextStyle(): StyleProp<TextStyle> {
  return {
    fontSize: getLayoutDescriber().bodyFontSize(),
    fontWeight: '700',
    fontFamily: Styles.FontFamily.gothamRegular,
  };
}
export default {
  getOnBoardingButton,
  linkExistingAccountStyleDescriptor,
  getWelcomeStatusBarStyleDescriptor,
  getWelcomeViewBckGrndStyleDescriptor,
  baseAccountContainerDescriptor,
  getOrTextDescriptor,
  getGoToSettings,
  getVersionTextDescriptor,
  getLogoContainer,
  getContainer,
  getManualLinktxt,
  getWelcomeOverLayImage,
  getRedeemColor,
  getTrailBlazerIcon,
  getSmartShopper,
  renderPointsToNextRewardLbl,
  getFocusAwareStatusBar,
  getLineContainer,
  getWelcomeButtonStyles,
  locationCodebgColor,
  getLetsGoStyle,
  getOneTimePayEarnColor,
  getRewardsIcon,
  renderYourBalanceRewardLbl,
  actionLinkText,
  getEliteBuyerTier,
  onboardingLinklocationSuccessTextColor,
  getBodyTextStyles,
  getOneTimeTitle,
  getStatusSystem,
  seeMoreDetailtxt,
  getMemberTier,
  getLocationCodeText,
  locationCodeSaveButtonTextStyle,
  getTrialBlazerWebIcon,
  getPasswordLoginTextStyleDescriptor,
  getLinkLocationButton,
};
